exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3IQBsw1K2G1sEDGwZobP1i{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}._2YhLfKALJBvJYC1hU5N3Zu{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto}._1pSw37WGUVvjhjudzB4YqW{font-weight:600;font-size:12px}html[dir=ltr] ._1pSw37WGUVvjhjudzB4YqW{padding:15px 0 10px 10px}html[dir=rtl] ._1pSw37WGUVvjhjudzB4YqW{padding:15px 10px 10px 0}._2TLYfmijjPv4jc7BIBFjWq{-webkit-box-flex:1;-ms-flex:1;flex:1}html[dir=ltr] ._3ck3JDyCZlNHKT9RF9C2DV{padding-right:25px}html[dir=rtl] ._3ck3JDyCZlNHKT9RF9C2DV{padding-left:25px}._2RcCeAXv-R2YdFX6wWytcr{font-weight:600;font-size:12px}html[dir] ._1HwmoVjMzgWWDT9kelzRX9{padding-top:11px}", ""]);

// exports
exports.locals = {
	"outerContainer": "_3IQBsw1K2G1sEDGwZobP1i",
	"columnWrapper": "_2YhLfKALJBvJYC1hU5N3Zu",
	"headerText": "_1pSw37WGUVvjhjudzB4YqW",
	"column": "_2TLYfmijjPv4jc7BIBFjWq",
	"listContainer": "_3ck3JDyCZlNHKT9RF9C2DV",
	"inspectorHeader": "_2RcCeAXv-R2YdFX6wWytcr",
	"inspectorContainer": "_1HwmoVjMzgWWDT9kelzRX9"
};